import { Navigate, Outlet, useNavigate } from "react-router-dom"
import { useLocation } from "react-router-dom";
import Footer from "../components/footer";
import { useEffect, useState } from "react";
import Helpers from "../services/helpers";
import Header from '../components/header'
import SideBar from "../components/sideMenu";
import SubFooterWeb from "../components/sub-footerWeb";

const Layout = () => {
    const Token = Helpers.getTokenData();
    if (Token?.access_token) {
        return <Navigate to="/" replace />
    }
    return (
        <>
            {/* <Header />
            <div style={{ marginTop: '70px',marginBottom:10}}>
                <Outlet />
            </div>    */}

            <section className='sideBarSection'>
                <SideBar />
                <section className='mainContent'>
                    <Header />
                    <div className="webCastomMargen">
                        <Outlet />
                    </div>
                    <Footer />
                    <div className='WebFooter'>
                        <SubFooterWeb />
                    </div>
                </section>
            </section>
        </>
    )
}

export default Layout;